import { render, staticRenderFns } from "./DataTableStageConfigActivityProvider.vue?vue&type=template&id=2a46db76&scoped=true&"
import script from "./DataTableStageConfigActivityProvider.vue?vue&type=script&lang=js&"
export * from "./DataTableStageConfigActivityProvider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=2a46db76&scoped=true&lang=css&"
import style1 from "./DataTableStageConfigActivityProvider.vue?vue&type=style&index=1&id=2a46db76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46db76",
  null
  
)

export default component.exports